import {
  APP_INIT_START,
  APP_INIT_SUCCESS,
  APP_INIT_FAILED,
} from '../actions/actionTypes';

const initialState = {
  initializing: true,
  initialized: false,
  errors: {
    initializing: null,
  },
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case APP_INIT_START:
      return {
        ...state,
        initializing: true,
      };
    case APP_INIT_SUCCESS:
      return {
        ...state,
        initializing: false,
        initialized: true,
        errors: {
          ...state.errors,
          initializing: null,
        },
      };
    case APP_INIT_FAILED:
      return {
        ...state,
        initializing: false,
        initialized: false,
        errors: {
          ...state.errors,
          initializing: action.error,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default appReducer;
